import { FetchActivityChartDataRequestPayload } from "@/data/payload/treatment/fetch-activity-chart-data-request-payload";
import { ActivityByProgressDayInfoEntity } from "@/domain/entity/treatment/activity-by-progress-day-info-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchActivityChartDataUsecase {
  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    treatmentInfoUuid: string,
    planUuid: string
  ): Promise<SATResult<ActivityByProgressDayInfoEntity, SATError>> {
    console.log("[FetchActivityChartDataUsecase] :: execute :: planUuid", planUuid);
    const payload: FetchActivityChartDataRequestPayload = {
      patientUuid,
      treatmentInfoUuid,
      planUuid: planUuid,
    };
    const result = await this.treatmentRepo.fetchActivityChartData(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    console.log("[FetchActivityChartDataUsecase] :: execute :: result.value", result.value);
    return SATResult.success(result.value);
  }
}
